exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-flex {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.footer {\r\n  background: var(--grey-800);\r\n  height: 60px;\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n  -ms-flex-align: center;\r\n  -webkit-align-items: center;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  color: var(--color-white);\r\n  position: fixed;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  z-index: 3;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/footer/styles.css
// module id = 2010
// module chunks = 29